import { ROUTES } from "@/_old/constants/routes";
import { useActionsTrack } from "@/_old/features/analytics";
import { CalendarCheck } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { InsightsCardsConsumption } from "../insights-cards-consumption/insights-cards-consumption";
import { InsightsCardsConsumptionSkeleton } from "../insights-cards-consumption/insights-cards-consumption-skeleton";
import { useDayUseBookings } from "./day-use-bookings.hooks";

export function DayUseBookings({
  startDate,
  endDate,
  companyId,
  carousel = false,
}: {
  startDate: string;
  endDate: string;
  companyId: number;
  carousel?: boolean;
}) {
  const { onActionClick } = useActionsTrack();

  const navigate = useNavigate();

  const [translate] = useTranslation(["dashboard-charts"]);

  const { data, isLoading } = useDayUseBookings({
    startDate,
    endDate,
    companyId,
  });

  if (isLoading || !data) {
    return <InsightsCardsConsumptionSkeleton carousel={carousel} />;
  }

  return (
    <InsightsCardsConsumption
      tag={
        data.total === 0
          ? translate("dashboard-greater-use-empty-day")
          : translate("dashboard-greater-use")
      }
      description={
        data.total === 0
          ? translate("dashboard-greater-use-empty-content-description")
          : translate("dashboard-greater-use-description")
      }
      subtitle={translate("dashboard-greater-use-subtitle", {
        total: data?.total,
      })}
      buttonText={translate("dashboard-greater-use-button-text")}
      icon={<CalendarCheck size={18} />}
      emptyContent={
        !data.total
          ? (translate("dashboard-greater-use-empty-content") as string)
          : undefined
      }
      content={
        <div
          dangerouslySetInnerHTML={{
            __html: translate("dashboard-greater-use-content", {
              day: translate(`dashboard-${data?.day?.toLowerCase()}`),
            }) as string,
          }}
        />
      }
      type={carousel ? "good" : "default"}
      onClick={() => {
        onActionClick("CLICK_INSIGHT_DAYUSE", "DASHBOARD");
        navigate(ROUTES.INSIGHTS);
      }}
      carousel={carousel}
    />
  );
}
